import { SecurityToken } from "../PoolContext";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "@reduxjs/toolkit";
import { actionCreators, State } from "../state";
import { useEffect, useState } from "react"
import TabsMenu from "./TabsMenu";
import { PrimarySaleGet, LiquidityPool } from "../PoolContext";
import { Link } from "react-router-dom"
import Cookies from 'universal-cookie';
import Popup, { DexxPopup } from '../components/Popup'
import LiquidationPopup from "../components/popup/LiquidationPopup"
import CreateLPPopup from "./popup/CreateLPPopup";
import SecondaryMarketStatistics from "./tokenBody/tabs/SecondaryMarketStatistics";
import TokenControlFunctionsTab from "./tokenBody/issuerTabs/TokenControlFunctionsTab";
import IssuanceStatusTab from "./tokenBody/issuerTabs/IssuanceStatusTab";
import InvestorBreakdown from "./tokenDetails/InvestorBreakdownTab";
import CapTableTab from "./tokenBody/issuerTabs/CapTableTab";
import PerformanceDetailsTab from "./tokenBody/issuerTabs/PerformanceDetailsTab";
import LiquidityPoolIssuerTab from "./tokenBody/issuerTabs/LiquidityPoolIssuerTab";

const cookies = new Cookies();

export default function IssuerTokenBody(props: { tokenInfo: SecurityToken, media: any }): JSX.Element {
    console.log(props.tokenInfo)
    const dispatch = useDispatch()
    const actions = bindActionCreators(actionCreators, dispatch)
    const [tokenStats, setTokenStats] = useState<any>()
    const [issuedPrimarySales, setIssuedPrimarySales] = useState<PrimarySaleGet[]>([])
    const [issuedLiquidityPools, setIssuedLiquidityPools] = useState<LiquidityPool[]>([])
    const [filteredLP, setFilteredLP] = useState<LiquidityPool[]>([])
    const [tokenPSs, setTokenPSs] = useState<PrimarySaleGet[]>([])

    const detailAccountState = useSelector((state: State) => state.detailAccount)
    const userCtx = detailAccountState.payload
    const offset = userCtx?.timezone_offset ? userCtx.timezone_offset : 0
    const isDev = cookies.get("env") === "develop"
    const isSecondaryMarketActive = props.tokenInfo.lp_flag || props.tokenInfo.p2p_flag

    const [liquidationPriceRequest, setLiquidationPriceRequest] = useState<any[]>([])
    const [liquidityPoolCreationRequest, setLiquidityPoolCreationRequest] = useState<any[]>([])

    const [showPopUp, setShowPopUp] = useState<boolean>(false)
    const [titlePopUp, setTitlePopUp] = useState<string>("")
    const [msgPopUp, setMsgPopUp] = useState<string>("")
    const [showLiquidationPopUp, setShowLiquidationPopUp] = useState<boolean>(false)
    const [showCreateLPPopUp, setShowCreateLPPopUp] = useState<boolean>(false)
    const [nextSuffix, setNextSuffix] = useState<number>(0)
    const tokenInfo = props.tokenInfo

    let isLiquidated = !(tokenInfo.buyback_price && tokenInfo.buyback_price === "0")

    let tokensSold: any
    try {
        tokensSold = parseInt(tokenInfo.shares_issued)
    } catch (e) { tokensSold = 0 }

    function handleClosePopUp() {
        setTitlePopUp("")
        setMsgPopUp("")
        setShowPopUp(false)
    }


    useEffect(() => {
        if (liquidationPriceRequest.length > 1) {
            setShowPopUp(true)
            switch (liquidationPriceRequest[0]) {
                case 200:
                case 204:
                    setTitlePopUp("Success")
                    setMsgPopUp("We are reviewing your Liquidation request.")
                    break;
                default:
                    setTitlePopUp("Sorry!")
                    setMsgPopUp("We encountered an error saving your data.")
                    break;
            }
        }
    }, [liquidationPriceRequest])

    useEffect(() => {
        if (liquidityPoolCreationRequest.length > 1) {
            setShowPopUp(true)
            switch (liquidityPoolCreationRequest[0]) {
                case 200:
                case 204:
                    setTitlePopUp("Success")
                    setMsgPopUp("We are reviewing your Liquidity Pool request.")
                    break;
                default:
                    setTitlePopUp("Sorry!")
                    setMsgPopUp("We encountered an error saving your data.")
                    break;
            }
        }
    }, [liquidityPoolCreationRequest])

    useEffect(() => {
        if (tokenInfo.uuid && tokenInfo.uuid !== "0") {
            actions.getTokenStats(tokenInfo.uuid, setTokenStats)
            actions.getIssuerLiquidityPools(tokenInfo.uuid, setIssuedLiquidityPools)
        }
        actions.getIssuerPrimarySales(setIssuedPrimarySales)

    }, [tokenInfo])

    useEffect(() => {
        if (tokenInfo.uuid) {
            const tmp = issuedPrimarySales.filter(v => v.token_uuid === tokenInfo.uuid)
            setTokenPSs(tmp)
        }
    }, [issuedPrimarySales])

    useEffect(() => {
        let filtered = [...issuedLiquidityPools]
        filtered = filtered.filter((i) => { return i.deleted === undefined || i.deleted === false })
        setFilteredLP(filtered)
        setNextSuffix(issuedLiquidityPools ? issuedLiquidityPools.length : 0)
    }, [issuedLiquidityPools])

    const headers = [...["Issuance Status", "Investor breakdown", "Cap table"],
        ...(isDev ? ["Market statistics"] : []),  ...isSecondaryMarketActive ? ["Liquidity pool"] : [], 
        ...(isLiquidated ? [] : ["Token control functions"]), ...["Performance details"]]
    return <>
        <DexxPopup show={showLiquidationPopUp} title={"Liquidation"}
            msg={<LiquidationPopup tokensSold={tokensSold} price={parseFloat(tokenInfo.price)} uuid={tokenInfo.uuid}
                setLiquidationPriceRequest={setLiquidationPriceRequest} closeFunction={() => setShowLiquidationPopUp(false)} />}
            btnConfirm={false} close={() => { setShowLiquidationPopUp(false) }} btnOk={false} />
        <DexxPopup show={showCreateLPPopUp} title={"Create Liquidity Pool"}
            msg={<CreateLPPopup
                closeFunction={function () {
                    setShowCreateLPPopUp(false);
                    actions.getIssuerLiquidityPools(tokenInfo.uuid, setIssuedLiquidityPools)
                }}
                setLiquidityPoolCreationRequest={setLiquidityPoolCreationRequest}
                tokenA={tokenInfo}
                lpNum={nextSuffix} />}
            helpMsg={
                <div className="p-5 font-roboto font-base text-primary text-lg">
                    <div>
                        For creation of a liquidity pool select the desired initial
                        price of the token and then the XEUR you will allocate.
                    </div>
                    <div>
                        The number of asset tokens required will be calculated for you.
                    </div>
                    <div>
                        For more detailed information
                        <Link to={"/support"} className="text-succ2">click here</Link>.
                    </div>
                </div>
            }
            btnConfirm={false} close={() => { setShowCreateLPPopUp(false) }} btnOk={false} />
        <Popup show={showPopUp} title={titlePopUp} msg={msgPopUp} btnOk={true} close={handleClosePopUp}></Popup>
        <div className="">
            <TabsMenu
                headers={headers}
                contents={[...
                    [<IssuanceStatusTab tokenInfo={tokenInfo} stats={tokenStats} primarySales={tokenPSs} offset={offset} />,
                    <InvestorBreakdown tokenStats={tokenStats} />, <CapTableTab tokenStats={tokenStats} />],
                ...isDev ? [<SecondaryMarketStatistics tokenUuid={tokenInfo.uuid} />] : [],
                ...isSecondaryMarketActive ? [<LiquidityPoolIssuerTab lps={filteredLP} offset={offset} onClick={() => {setShowCreateLPPopUp(true)}} />] : [],
                ...isLiquidated ? [] : [<TokenControlFunctionsTab tokenInfo={tokenInfo} 
                    onClickLiquidation={() => {setShowLiquidationPopUp(true)}} />], 
                ...isDev ? [<PerformanceDetailsTab />] : []]} />
        </div>
    </>
}